// 支付方式
export const PAYMENT_METHOD = {
  ALIPAY: 'alipay',
  WECHAT: 'wei',
  BANK: 'bank',
  BALANCE: 'balance',
}

// 支付类型
export const PAY_TYPE = {
  ALIPAY: 2, // 支付宝支付
  WECHAT: 3, // 微信支付
  BANK: 8, // 银行转账
  BALANCE: 1, // 余额支付
}
